export default __webpack_public_path__ + "static/media/logo-agnes-illustrator.9aa4287a.png";